import { ChangeEvent, EventHandler } from 'react';
import { Format } from './formatters';

type FieldType = 'CPF' | 'CPFCNPJ' | 'EMAIL' | 'PHONE' | 'DATE' | "COUNTRY_CODE_NUMBER" | "CEP";

const formatValue = (value: string, fieldType: FieldType): string => {
    switch (fieldType) {
        case 'CPFCNPJ':
            return Format.maskCPFCNPJ(value);
        case 'EMAIL':
            return Format.maskCPFCNPJ(value);
        case 'PHONE':
            return Format.maskPhone(value);
        case 'DATE':
            return Format.maskDate(value);
        case 'CPF':
            return Format.maskCPF(value);
        case "CEP":
            return Format.maskCEP(value);
        case "COUNTRY_CODE_NUMBER":
            return Format.formatCountryCode(value);
    }
};
const getMaxLength = (fieldType: FieldType): number => {
    switch (fieldType) {
        case 'CPF':
            return 14;
        case 'CPFCNPJ':
            return 18;
        case 'PHONE':
            return 13;
        case 'DATE':
            return 10;
        case "COUNTRY_CODE_NUMBER":
            return 4;
        case "CEP":
            return 10;
        default:
            return 255;
    }
};

const handleChange =
    (
        fieldType: FieldType,
        callback?: EventHandler<ChangeEvent<HTMLInputElement>>
    ) =>
    (e: ChangeEvent<HTMLInputElement>) => {
        e.target.value = formatValue(e.target.value, fieldType);

        if (callback) return callback(e);
    };

const inputMasker = { formatValue, getMaxLength, handleChange };

export default inputMasker;
